import { render, staticRenderFns } from "./CenarioLoading.vue?vue&type=template&id=4c047e80&scoped=true&"
import script from "./CenarioLoading.vue?vue&type=script&lang=js&"
export * from "./CenarioLoading.vue?vue&type=script&lang=js&"
import style0 from "./CenarioLoading.vue?vue&type=style&index=0&id=4c047e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c047e80",
  null
  
)

export default component.exports